import React, { Fragment } from "react";
import { Button } from "../Button";
import { useTranslation } from "../hooks/useTranslation";
/** Form Button component
 * Encapsulates cancel, edit, and submit buttons.
 * Depending on which call back and viewState that
 * is passed in, the appropriate buttons with appropriate
 * labels will be passed in.
 */
export var FormButtons = function (_a) {
    var viewState = _a.viewState, saveState = _a.saveState, onCancel = _a.onCancel, onEdit = _a.onEdit, onSubmit = _a.onSubmit, id = _a.id, editDisabled = _a.editDisabled, _b = _a.hideCancel, hideCancel = _b === void 0 ? false : _b, children = _a.children;
    var t = useTranslation();
    return (React.createElement(Fragment, null,
        viewState === "edit" && (React.createElement(Fragment, null,
            !hideCancel && (React.createElement(Button, { label: onEdit ? t("Cancel") : t("Reset"), onClick: onCancel, disabled: saveState === "saving", id: id && "".concat(id, "__cancel"), dataHook: onEdit ? "cancel-button" : "reset-button" })),
            onSubmit ? (React.createElement(Button, { type: "primary", onClick: onSubmit, label: t("Save"), disabled: saveState === "saving", dataHook: "save-button" })) : (children))),
        viewState === "read" && (React.createElement(Button, { label: t("Edit"), type: "primary", onClick: onEdit, disabled: onEdit === undefined || editDisabled, id: id && "".concat(id, "__edit"), dataHook: "edit-button" }))));
};
